import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { ICountry, IStates } from '../Shared/models/GeneralModel';
@Injectable({
    providedIn: 'root',
})

export class GeneralService {
    private baseURL: string;
    constructor(private http: HttpClient,
    ) {
        this.baseURL = environment.apiBaseUrl;
    }

    public options = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

    getCountries(): Observable<ICountry[]> {
        return this.http.get<ICountry[]>(
            `${this.baseURL}/General/GetCountries`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const Countries = res.body as ICountry[];
                    return Countries;
                }),
                catchError(this.handleError)
            );
    }

    getUSStates(): Observable<IStates[]> {
        return this.http.get<IStates[]>(
            `${this.baseURL}/General/GetUSStates`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as IStates[];
                    return states;
                }),
                catchError(this.handleError)
            );
    }

    GetCountryStateList(CountryCode): Observable<IStates[]> {
        return this.http.get<IStates[]>(
            `${this.baseURL}/General/GetCountryStateList?CountryCode=${CountryCode}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as IStates[];
                    return states;
                }),
                catchError(this.handleError)
            );
    }

    getCompanyId(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/General/GetCompanyId`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const states = res.body as any;
                    return states;
                }),
                catchError(this.handleError)
            );
    }

    GetVendorTypes(marketId): Observable<any> {
    return this.http.get<any>(
      `${this.baseURL}/admin/VendorType/GetVendorTypes/${marketId}`,
      { observe: 'response' })
      .pipe(
        map(res => {
          const result = res.body as any;
          return result;
        }),
        catchError(this.handleError)
      );
  }

    GetSecurityQuestion(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/General/GetVendorLoginSecurityQuestion`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    getWebrentalMarketRules(marketId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/General/GetWebrentalMarketRules?marketId=${marketId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    ValidateWRMarketByCompanyId(marketId): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/General/ValidateWRMarketByCompanyId?marketId=${marketId}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const result = res.body as any;
                    return result;
                }),
                catchError(this.handleError)
            );
    }

    checkWIFIApplicationForBoothsPart(marketId: number, boothNumbers: string[]): Observable<any> {
        return this.http.post<any>(
            `${this.baseURL}/General/CheckWIFIApplicationForBoothsPart?marketId=${marketId}`,
            boothNumbers, // body (List<string>)
            { observe: 'response' }
        ).pipe(
            map(res => res.body),
            catchError(this.handleError)
        );
    }

    SevenMilesValidateBooking(model): Observable<any> {
        const url = `${this.baseURL}/General/SevenMilesValidateBooking`;
        return this.http.post<any>(url, model, this.options)
            .pipe(
                map(res => {
                    const response = res as any;
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    GetAllDiscountOtherrentalCharges(marketId): Observable<any> {
        const url = `${this.baseURL}/General/GetAllDiscountOtherrentalCharges?marketId=${marketId}`;
        return this.http.get<any>(url, { observe: 'response' })
            .pipe(
                map(res => res.body),
                catchError(this.handleError)
            );
    }

  GetBTCloudLicensing(marketId): Observable<any> {
    const url = `${this.baseURL}/General/GetBTCloudLicensing?marketId=${marketId}`;
    return this.http.get<any>(url, { observe: 'response' })
      .pipe(
        map(res => res.body),
        catchError(this.handleError)
      );
  }

  DisplayBidEntryReceipt(marketId,model): Observable<any> {
    const url = `${this.baseURL}/Rental/DisplayBidEntryReceipt?marketId=${marketId}`;
    return this.http.post<any>(url, model, this.options)
      .pipe(
        map(res => {
          const response = res as any;
          return response;
        }),
        catchError(this.handleError)
      );
  }

    private handleError(error: HttpErrorResponse) {
        console.error('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}
